// configEnv.js
// Obtain env variables at run-time instead of at build-time
const runtimeEnv = window.RUNTIME_ENV || {};

const environment = {
    region: runtimeEnv.REACT_APP_REGION || process.env.REACT_APP_REGION,
    userPoolId: runtimeEnv.REACT_APP_USER_POOL_ID || process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: runtimeEnv.REACT_APP_CLIENT_ID || process.env.REACT_APP_CLIENT_ID,
    bucketName: runtimeEnv.REACT_APP_BUCKET_NAME || process.env.REACT_APP_BUCKET_NAME,
    identityPoolId: runtimeEnv.REACT_APP_IDENTITY_POOL_ID || process.env.REACT_APP_IDENTITY_POOL_ID,
    apiEndpoint: runtimeEnv.REACT_APP_API_ENDPOINT || process.env.REACT_APP_API_ENDPOINT
};

// Validate configuration
const requiredKeys = ['region', 'userPoolId', 'userPoolWebClientId'];
const missingKeys = requiredKeys.filter(key => !environment[key]);

if (missingKeys.length > 0) {
    console.error('Missing required configuration:', missingKeys);
}

export default environment;
